import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import { useEffect, useLayoutEffect, useState } from 'react'
import Header from './components/Layouts/Header'
import WhatsAppFab from './components/Common/WhatsAppFab'
import RedirectHandler from './components/Common/RedirectHandler'
import Breadcrumbs from './components/Common/Breadcrumbs'
import { BreadcrumbProvider } from './context/BreadcrumbContext'
import RouteSEO from './seo/RouteSEO'
import SiteJsonLd from './seo/SiteJsonLd'
import PublicRoutes from './routes/publicRoutes'
import './App.css'

function scrollWindowToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollWindowToTop();
    const raf = requestAnimationFrame(scrollWindowToTop);
    const t = window.setTimeout(scrollWindowToTop, 120);
    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t);
    };
  }, [pathname]);

  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname === '/admin' || pathname.startsWith('/admin/');
  const [clientReady, setClientReady] = useState(false);

  useEffect(() => {
    setClientReady(true);
  }, []);

  return (
    <BreadcrumbProvider>
      <ScrollToTop />
      {clientReady ? <RedirectHandler /> : null}
      {!isAdmin ? <Header /> : null}
      <main className={isAdmin ? 'admin-route-main' : undefined}>
        {!isAdmin ? <SiteJsonLd /> : null}
        {!isAdmin ? <Breadcrumbs nonce="ppp-2026-gtm-nonce" /> : null}
        <PublicRoutes />
        {!isAdmin ? <RouteSEO /> : null}
      </main>
      {!isAdmin && clientReady ? <WhatsAppFab /> : null}
    </BreadcrumbProvider>
  );
}

export default function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  )
}
